<template>
  <main>
    <wo-region class="po-focus-page">
      <wo-layout>
        <wo-grid>
          <wo-column width-xl="4">
            <div class="po-focus-page__content">
              <wo-spacer mod-xl />
              <wo-title tag-name="h1" tag-style="h1" mod-block>{{ title }}</wo-title>
              <wo-typography v-if="message">
                <p v-wo-color.light v-wo-text.xl>{{ message }}</p>
              </wo-typography>
              <wo-spacer mod-l />
              <slot />
              <wo-spacer mod-l />
              <wo-grid mod-stacked v-if="hasFooter">
                <wo-column width="5" v-wo-v-align:center>
                  <img :src="logoPath" />
                </wo-column>
                <wo-column width="7" v-wo-v-align:center>
                  <slot name="footer" />
                </wo-column>
              </wo-grid>
            </div>
          </wo-column>
          <wo-column width-xl="8" v-wo-v-align:center>
            <div class="po-focus-page__image" :style="coverStyle"></div>
          </wo-column>
        </wo-grid>
      </wo-layout>
    </wo-region>
  </main>
</template>
<script>

import { mapState } from 'vuex'

export default {
  name: 'FocusPage',
  props: {
    title: String,
    message: String
  },
  computed: mapState({
    env: state => state.environment.current,
    hasFooter () {
      return !!this.$slots['footer']
    },
    logoPath () {
      return this.env.logoPath
    },
    coverStyle () {
      return {
        backgroundImage: `url(${this.env.coverPath}`
      }
    }
  })
}
</script>

<style lang="scss">

  .po-focus-page__content {
    max-width: 490px;
    margin: 0 auto;
  }

  .po-focus-page__image {
    height: 100%;
    background-position: center center;
    background-size: cover;
  }
</style>
